

































import { Vue, Component } from "vue-property-decorator";

// Types
import { ITicket } from "@/models/tickets";

@Component({
  components: {
    "ticket-provider": () =>
      import("@/components/app/global/tickets/ticketProvider.vue"),
    "client-ticket-billboard": () =>
      import("@/components/app/client/support/clientTicketBillboard.vue"),
    "client-ticket-details-component": () =>
      import(
        "@/components/app/client/support/clientTicketDetailsComponent.vue"
      ),
    "related-product-component": () =>
      import("@/components/app/global/ticket/relatedProductComp.vue"),
    "client-ticket-feed": () =>
      import("@/components/app/client/support/clientTicketFeed.vue"),
    "client-ticket-status": () =>
      import("@/components/app/client/support/clientTicketStatus.vue")
  }
})
export default class ClientSupportTicketLayout extends Vue {
  // Data

  public ticketId: ITicket["id"] = this.$route.params.ticketId;
}
